// extracted by mini-css-extract-plugin
export default {"categoryPaidWarning":"AnnuncioCrea_categoryPaidWarning__pnBIm"};